import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/accounts',
    name: 'Account',
    component: {
      name: 'AdminAccount',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'account',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminAccountIndex',
        component: () => import('../views/AccountIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminAccountNew',
        component: () => import('../views/AccountInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminAccountIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminAccountShow',
        component: () => import('../views/AccountShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminAccountIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminAccountDetails',
            component: () => import('../views/AccountDetails.vue'),
            meta: {
              backRoute: { name: 'AdminAccountIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminAccountEdit',
            component: () => import('../views/AccountInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminAccountDetails' },
            },
          },
          {
            path: 'contacts',
            name: 'AdminContacts',
            component: {
              name: 'AdminContact',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminAccountIndex' },
              resource: 'contact',
            },
            children: [
              {
                path: '',
                name: 'AdminContact',
                component: () => import('../views/contact/AccountContacts.vue'),
                meta: {
                  backRoute: { name: 'AdminAccountIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminContactNew',
                component: () => import('../views/contact/ContactInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminContacts' },
                },
              },
              {
                path: ':contactId(\\d+)',
                name: 'AdminContactShow',
                component: () => import('../views/contact/ContactShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminContacts',
                  },
                  tArgs: route => ({ name: route?.params?.contactId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminContactDetails',
                    component: () => import('../views/contact/ContactDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminContacts' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminContactEdit',
                    component: () => import('../views/contact/ContactInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminContactDetails' },
                    },
                  },
                ]
              }
            ],
          },
          /* ------- ADDRESSES ------- */
          {
            path: 'addresses',
            name: 'AdminAccountAddress',
            component: {
              name: 'AdminAccountAddress',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminAccountDetails' },
              resource: 'address',
            },
            children: [
              {
                path: '',
                name: 'AdminAccountAddressIndex',
                component: () => import('../views/address/AccountAddresses.vue'),
                meta: {
                  backRoute: { name: 'AdminAccountDetails' },
                },
              },
              {
                path: 'new',
                name: 'AdminAccountAddressNew',
                component: () => import('../views/address/AddressInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminAccountAddress' },
                },
              },
              {
                path: ':addressId(\\d+)',
                name: 'AdminAccountAddressShow',
                component: () => import('../views/address/AddressShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminAccountAddress',
                  },
                  tArgs: route => ({ name: route.params?.addressId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminAccountAddressDetails',
                    component: () => import('../views/address/AddressDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminAccountAddressIndex' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminAccountAddressEdit',
                    component: () => import('../views/address/AddressInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminAccountAddressShow' },
                    },
                  },
                ]
              }
            ],
          },
          {
            path: 'account_payment_methods',
            name: 'AdminAccountPaymentMethods',
            component: {
              name: 'AdminAccountPaymentMethod',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminAccountIndex' },
              resource: 'account_payment_method',
            },
            children: [
              {
                path: '',
                name: 'AdminAccountPaymentMethod',
                component: () => import('../views/accountPaymentMethod/AccountPaymentMethods.vue'),
                meta: {
                  backRoute: { name: 'AdminAccountIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminAccountPaymentMethodNew',
                component: () => import('../views/accountPaymentMethod/AccountPaymentMethodInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminPaymentMethods' },
                },
              },
              {
                path: ':accountPaymentMethodId(\\d+)',
                name: 'AdminAccountPaymentMethodShow',
                component: () => import('../views/accountPaymentMethod/AccountPaymentMethodShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminAccountPaymentMethods',
                  },
                  tArgs: route => ({ name: route?.params?.accountPaymentMethodId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminAccountPaymentMethodDetails',
                    component: () => import('../views/accountPaymentMethod/AccountPaymentMethodDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminAccountPaymentMethods' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminAccountPaymentMethodEdit',
                    component: () => import('../views/accountPaymentMethod/AccountPaymentMethodInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminAccountPaymentMethodDetails' },
                    },
                  },
                ]
              }
            ],
          },
          /* ------- PROJECTS ------- */
          {
            path: 'projects',
            name: 'AdminAccountProjects',
            component: () => import('../views/project/AccountProjects.vue'),
            meta: {
              backRoute: { name: 'AdminAccountIndex' },
              resource: 'project',
            },
          },
          /* ------ Logs ------- */
          {
            path: 'logs',
            name: 'AdminAccountLogs',
            component: () => import('../views/log/AccountLogs.vue'),
            meta: {
              backRoute: { name: 'AdminAccountIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'account_contacts',
    name: 'Contact',
    component: {
      name: 'AdminContacts',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'contact',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminContactIndex',
        component: () => import('../views/contact/ContactIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));